module.exports = __webpack_public_path__ + "img/4.97272e84.png";